import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';

export const meGetNotificationsUnreadCount = createQueryFn(
  QueryNameSpace.meGetNotificationsUnreadCount,
  async () => {
    const res = await DigiobcanApi.meGetNotificationsUnreadCount();

    return res.unread_count;
  },
);
